import { type AssetSearchFilters } from '@air/api/types';

/** Board scope stays on the search. Callers add the other `Clips.search` filters. */
export type PrivateWorkspaceAgentBoardAssetSearchFilters = Omit<AssetSearchFilters, 'board'>;

type GetPrivateWorkspaceAgentBoardAssetSearchFiltersParams = {
  boardId: string | undefined;
  filters: PrivateWorkspaceAgentBoardAssetSearchFilters | undefined;
};

export const getPrivateWorkspaceAgentBoardAssetSearchFilters = ({
  boardId,
  filters,
}: GetPrivateWorkspaceAgentBoardAssetSearchFiltersParams): AssetSearchFilters | undefined => {
  if (!boardId) {
    return filters;
  }

  return { ...filters, board: { is: boardId } };
};
